export default function initializeCategories() {
    window.onload = function() {
        const container = document.querySelector('.product-categories');
        const currentCategory = container ? container.querySelector('.current-cat') : null;

        if (container && currentCategory) {
            container.scrollLeft = currentCategory.offsetLeft - container.offsetLeft;
        }
    };
}
